import type { ReactNode } from "react";
import { createPortal } from "react-dom";

export default function FloatingPortal({ children }: { children: ReactNode }) {
  if (typeof document === "undefined" || !document.body) return null;
  return createPortal(children, document.body);
}
